import React from 'react';
import { Link } from 'react-router-dom';

const ERPIntegration = () => {
    return (
        <section className="py-20 sm:py-28 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-slate-50">
            <div className="max-w-7xl mx-auto">

                {/* Heading */}
                <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16">
                    <div className="inline-flex items-center gap-2 px-4 py-1 mb-4 text-xs font-semibold tracking-wide text-blue-600 uppercase bg-blue-50 rounded-full">
                        ERP Integration
                    </div>
                    <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4 tracking-tight">
                        Adeya IMS + Your ERP ={" "}
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                            Complete Control
                        </span>
                    </h2>
                    <p className="text-2xl mt-12 text-slate-900">
                        We don't replace your ERP. <span className='text-blue-700 font-bold'>We provide analytics to it.</span>
                    </p>
                </div>

                {/* Two Column Comparison */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-12">

                    {/* Your ERP */}
                    <div className="bg-white rounded-2xl p-8 border border-slate-200 shadow-lg hover:shadow-xl transition-all">
                        <div className="flex items-center gap-3 mb-6">
                            <div className="w-12 h-12 rounded-xl bg-slate-100 flex items-center justify-center">
                                <svg className="w-6 h-6 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                                </svg>
                            </div>
                            <h3 className="text-2xl font-bold text-slate-800">Your ERP</h3>
                        </div>
                        <ul className="space-y-3">
                            {['Billing & Invoicing', 'Accounting', 'GST Compliance', 'Sales Records'].map((item, idx) => (
                                <li key={idx} className="flex items-center gap-3">
                                    <div className="w-5 h-5 rounded-full bg-slate-100 flex items-center justify-center shrink-0">
                                        <svg className="w-3 h-3 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                    <span className="text-sm text-slate-600 font-medium">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Adeya IMS */}
                    <div className="bg-white rounded-2xl p-8 border-2 border-blue-500 shadow-2xl hover:shadow-blue-200/50 transition-all relative">
                        <div className="absolute -top-3 left-8 bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-[10px] font-black px-4 py-1 rounded-full uppercase tracking-widest shadow-lg">
                            Adeya IMS
                        </div>
                        <div className="flex items-center gap-3 mb-6 mt-2">
                            <div className="w-12 h-12 rounded-xl bg-blue-100 flex items-center justify-center">
                                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                </svg>
                            </div>
                            <h3 className="text-2xl font-bold text-slate-800">Adeya IMS</h3>
                        </div>
                        <ul className="space-y-3">
                            {['Real-Time Inventory', 'Multi-Store Visibility', 'Sales & Purchase Analytics', 'Low Stock Alerts'].map((item, idx) => (
                                <li key={idx} className="flex items-center gap-3">
                                    <div className="w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center shrink-0">
                                        <svg className="w-3 h-3 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                    <span className="text-sm text-slate-600 font-medium">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Bottom Line */}
                <div className="text-center max-w-3xl mx-auto">
                    <p className="text-lg sm:text-xl text-slate-700 font-medium mb-2">
                        Your ERP handles the books.
                    </p>
                    <p className="text-lg sm:text-xl text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600 font-bold">
                        Adeya IMS handles the inventory intelligence.
                    </p>
                    <div className="mt-6">
                        <Link
                            to="/contact"
                            className="inline-block px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5"
                        >
                            Book a Demo
                        </Link>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default ERPIntegration;